import axios from "axios";
import React, { useEffect, useState } from "react";
import { SHRIMP_LISTING_MASTER } from "../../../constants";
import {
  Chip,
  IconButton,
  Paper,
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  Box,
  Table,
} from "@mui/material";
import TimelineIcon from "@mui/icons-material/Timeline";
import CallIcon from "@mui/icons-material/Call";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import LongTextComponent from "../../Leads Page/LongTextComponent";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import FilterComponent from "./FilterComponent";

const ListingPageComponent = ({ }) => {
  const [filters, setFilters] = useState({
    region: "",
    page: 0, // Zero-based index
    pageSize: 20, // Default page size
    order: "DESC",
    mobileNo: ""
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [tableData, setTableData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const fetchData = async (filters) => {
    const { page, pageSize, region, order, mobileNo } = filters;
    try {
      const response = await axios.get(
        `${SHRIMP_LISTING_MASTER}?page=${page + 1
        }&limit=${pageSize}&region=${region}&order=${order}&mobileNo=${mobileNo === undefined ? "" : mobileNo}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      const { data } = response.data;

      setTableData(data.records);
      setTotalRows(data.totalCount);
      setLoading(false); // End loading
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLoading(false);
    }
  };

  //   useEffect(() => {
  //     fetchData(page, pageSize);
  //   }, []);

  const handleApplyFilters = (newFilters) => {
    fetchData(newFilters); // Adjust page and size as needed
  };

  const formatDate = (dateString) => moment(dateString).format("DD-MM-YYYY");

  const columns = [
    { key: "lastActionDate", header: "Last Action Date" },
    { key: "dealerCode", header: "Dealer Code" },
    { key: "mobileNo", header: "Mobile No" },
    { key: "dealerName", header: "Dealer Name" },
    { key: "dealerType", header: "Dealer Type" },
    { key: "farmerType", header: "Farmer Type" },
    { key: "farmerVillage", header: "Farmer Village" },
    { key: "postalCode", header: "Postal Pincode" },
    { key: "district", header: "District" },
    { key: "state", header: "State" },
    { key: "region", header: "Region" },
    { key: "zone", header: "Zone" },
    { key: "shrimpZone", header: "Shrimp Zone" },
    { key: "latitudeValue", header: "Latitude" },
    { key: "longitudeValue", header: "Longitude" },
    { key: "feedGodownCapacity", header: "Feed Godown Capacity" },
    { key: "feedType", header: "Feed Type" },
    { key: "prospectFarmerInd", header: "Prospect Farmer" },
    { key: "status", header: "Status" },
    { key: "remarks", header: "Remarks" },
    { key: "enteredBy", header: "Entered By" },
    { key: "employeeCode", header: "Employee Code" },
    { key: "createdAt", header: "Created At" },
    { key: "updatedAt", header: "Updated At" },
  ];

  const columnWidths = {
    SNo: "50px",
    createdAt: "150px",
    dealerCode: "150px",
    dealerName: "150px",
    dealerType: "120px",
    district: "150px",
    employeeCode: "150px",
    enteredBy: "150px",
    farmerType: "120px",
    farmerVillage: "150px",
    feedGodownCapacity: "150px",
    feedType: "120px",
    lastActionDate: "150px",
    latitudeValue: "150px",
    longitudeValue: "150px",
    mobileNo: "150px",
    postalCode: "150px",
    prospectFarmerInd: "120px",
    region: "150px",
    remarks: "200px",
    shrimpZone: "150px",
    state: "120px",
    status: "120px",
    updatedAt: "150px",
    zone: "120px",
  };

  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "asc",
  });

  const handleSort = (key) => {
    const isAsc = sortConfig.key === key && sortConfig.direction === "asc";
    setSortConfig({ key, direction: isAsc ? "desc" : "asc" });

    // Apply sorting logic on your table data
    const sortedData = [...tableData].sort((a, b) => {
      if (a[key] < b[key]) return isAsc ? -1 : 1;
      if (a[key] > b[key]) return isAsc ? 1 : -1;
      return 0;
    });

    // Update your state with the sorted data
    setTableData(sortedData);
  };

  const handleIconClick = () => { };

  const handleCallIconClick = (row) => {
    navigate("/dashboard", {
      state: {
        mobNo: row.mobileNo,
        lotNum: row.mobileNo,
      },
    });
  };

  const getColorForTag = (tag) => {
    switch (tag) {
      case "Open":
        return "error"; // React blue
      case "Close":
        return "warning"; // JavaScript yellow
      case "In Process":
        return "info"; // UI dark blue
      default:
        return "default"; // Default gray
    }
  };

  return (
    <>
      <Paper>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
          >
            Leads Table
          </Typography>

          <FilterComponent
            filters={filters}
            setFilters={setFilters}
            onApplyFilters={handleApplyFilters}
          />
        </div>

        <TableContainer
          sx={{
            boxShadow: 2,
            borderRadius: "8px",
            margin: "8px 0",
          }}
        >
          <Table
            sx={{ minWidth: 650, height: "100%", tableLayout: "fixed" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#F4F6F8",
                  height: "48px",
                  borderBottom: "2px solid #e0e0e0",
                }}
              >
                <TableCell
                  key={"Sno"}
                  align="center"
                  sx={{
                    width: columnWidths["SNo"] || "auto",
                    padding: "10px 8px",
                  }}
                >
                  SNo
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.key}
                    align="center"
                    sx={{
                      width: columnWidths[column.key] || "auto",
                      padding: "10px 8px",
                    }}
                    sortDirection={
                      sortConfig.key === column.key
                        ? sortConfig.direction
                        : false
                    }
                  >
                    <TableSortLabel
                      active={sortConfig.key === column.key}
                      direction={
                        sortConfig.key === column.key
                          ? sortConfig.direction
                          : "asc"
                      }
                      onClick={() => handleSort(column.key)}
                    >
                      {column.header}
                    </TableSortLabel>
                  </TableCell>
                ))}
                <TableCell
                  key={"action"}
                  align="center"
                  sx={{
                    width: "120px",
                    padding: "10px 8px",
                    position: "sticky", // Make the cell sticky
                    right: 0, // Align it next to the Action column
                    backgroundColor: "#EEF0F4", // Set background color for visibility
                    zIndex: 10, // Higher z-index to stay above other cells
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(tableData) && tableData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={27}>No Data Available Yet.</TableCell>
                </TableRow>
              ) : (
                tableData?.map((row, index) => (
                  <TableRow
                    key={row?.id || index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#FAFAFA",
                    }}
                  >
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["SNo"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {filters.page * filters.pageSize + index + 1}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["lastActionDate"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.lastActionDate === null || row.lastActionDate === undefined ? "-" : formatDate(row.lastActionDate)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["dealerCode"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.dealerCode === undefined || row?.dealerCode === null
                        ? "-"
                        : row?.dealerCode}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["mobileNo"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.mobileNo === null || row?.mobileNo === undefined
                        ? "-"
                        : row?.mobileNo}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["dealerName"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.dealerName || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["dealerType"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.dealerType || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["farmerType"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.farmerType || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["farmerVillage"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.farmerVillage || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["postalCode"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.postalCode || "-"}
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["district"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row.district || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["state"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.state || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["region"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row.region || "-"}
                      {/* <LongTextComponent
                        text={
                          row?.agent_remark === null ||
                          row?.agent_remark === undefined
                            ? "-"
                            : row?.agent_remark
                        }
                        maxLength={50}
                      /> */}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["zone"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row.zone || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["shrimpZone"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.shrimpZone || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["latitudeValue"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.latitudeValue || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["longitudeValue"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.longitudeValue || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["feedGodownCapacity"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.feedGodownCapacity || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["feedType"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.feedType || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["prospectFarmerInd"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.prospectFarmerInd === null ||
                        row?.prospectFarmerInd === undefined
                        ? "-"
                        : row?.prospectFarmerInd === true
                          ? "Yes"
                          : "No"}
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["status"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.status === null ? (
                        "-"
                      ) : (
                        <Chip
                          label={row.status}
                          color={`${getColorForTag(row.status)}`}
                          size="small"
                          sx={{
                            fontWeight: 500,
                            fontSize: "0.75rem",
                            textTransform: "capitalize",
                            px: 1,
                          }}
                        />
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["remarks"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      <LongTextComponent
                        text={
                          row?.remarks === null || row?.remarks === undefined || row?.remarks === ""
                            ? "-"
                            : row.remarks
                        }
                        maxLength={50}
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: 150,
                        }}
                      />
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["enteredBy"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row.enteredBy || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["employeeCode"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.employeeCode || "-"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["createdAt"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.createdAt === null || row.createdAt === undefined
                        ? "-"
                        : formatDate(row.createdAt)}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        width: columnWidths["updatedAt"] || "auto",
                        padding: "10px 8px",
                      }}
                    >
                      {row?.updatedAt === null || row.updatedAt === undefined
                        ? "-"
                        : formatDate(row.updatedAt)}
                    </TableCell>

                    <TableCell
                      align="left"
                      sx={{
                        width: "120px",
                        padding: "10px 8px",
                        position: "sticky", // Make the cell sticky
                        right: 0, // Align it next to the Action column
                        backgroundColor: "#EEF0F4", // Set background color for visibility
                        zIndex: 10, // Higher z-index to stay above other cells
                        boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "6px",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "4px 0",
                        }}
                      >
                        {/* <Tooltip title="Timeline" arrow>
                          <IconButton
                            onClick={() => handletimelineClick(row)}
                            sx={{
                                width: 28,
                                height: 28,
                                padding: "4px",
                                border: "1px solid #ccc",
                                borderRadius: "6px",
                                backgroundColor: "#fff",
                                transition: "all 0.2s",
                                "&:hover": {
                                  backgroundColor: "#f0f0f0",
                                },
                              }}
                            color="primary"
                          >
                            <TimelineIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Tooltip> */}

                        {/* <Tooltip title="View" arrow>
                          <IconButton
                            sx={{
                              width: 28,
                              height: 28,
                              padding: "4px",
                              border: "1px solid #ccc",
                              borderRadius: "6px",
                              backgroundColor: "#fff",
                              transition: "all 0.2s",
                              "&:hover": {
                                backgroundColor: "#f0f0f0",
                              },
                            }}
                            color="primary"
                            onClick={() => handleIconClick(row)}
                          >
                            <VisibilityIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Tooltip> */}

                        <Tooltip title="Call" arrow>
                          <IconButton
                            sx={{
                              width: 28,
                              height: 28,
                              padding: "4px",
                              border: "1px solid #ccc",
                              borderRadius: "6px",
                              backgroundColor: "#fff",
                              transition: "all 0.2s",
                              "&:hover": {
                                backgroundColor: "#f0f0f0",
                              },
                            }}
                            color="primary"
                            onClick={() => handleCallIconClick(row)}
                          >
                            <CallIcon fontSize="small" color="primary" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalRows ?? 0} // Fallback to 0 if totalRows is undefined or null
          page={filters.page >= 0 ? filters.page : 0} // Ensure the page value is valid
          onPageChange={(event, newPage) => {
            setFilters((prevFilters) => {
              const updatedFilters = { ...prevFilters, page: newPage };
              fetchData(updatedFilters); // Fetch leads with the updated page
              return updatedFilters;
            });
          }}
          rowsPerPage={filters.pageSize > 0 ? filters.pageSize : 10} // Use pageSize from state, fallback to 10 if invalid
          onRowsPerPageChange={(event) => {
            const newPageSize = parseInt(event.target.value, 10);
            setFilters((prevFilters) => {
              const updatedFilters = {
                ...prevFilters,
                pageSize: newPageSize,
                page: 0,
              }; // Reset to page 0 when rows per page change
              fetchData(updatedFilters); // Fetch leads with the updated pageSize
              return updatedFilters;
            });
          }}
          rowsPerPageOptions={[10, 20, 25, 50]} // Options for rows per page
        />
      </Paper>
    </>
  );
};

export default ListingPageComponent;
